import React from 'react';
import PropTypes from 'prop-types';

const SideBarHomeLogo = ({ bgColor = '#6D758E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 16.6666C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6666V7.90832C2.49991 7.78133 2.52885 7.656 2.5846 7.5419C2.64035 7.4278 2.72143 7.32795 2.82167 7.24998L9.48833 2.06498C9.63462 1.95119 9.81467 1.8894 10 1.8894C10.1853 1.8894 10.3654 1.95119 10.5117 2.06498L17.1783 7.24998C17.2786 7.32795 17.3597 7.4278 17.4154 7.5419C17.4712 7.656 17.5001 7.78133 17.5 7.90832V16.6666ZM15.8333 15.8333V8.31498L10 3.77832L4.16667 8.31498V15.8333H15.8333Z"
        fill={bgColor}
      />
    </svg>
  );
};

SideBarHomeLogo.propTypes = {
  bgColor: PropTypes.string,
};

export default SideBarHomeLogo;